import { useContext, useEffect, useState } from 'react';
import { useTheme } from 'styled-components';

import { updateUserDetails } from '../../../api/Optimise';
import { AppContext } from '../../../context/AppContext';
import Toggle from '../../Toggle';

import InformationPanel from './InformationPanel';

const OnOffSettings = ({ loadUser, setShowError }) => {
  const theme = useTheme();
  const { userDetails, userSub } = useContext(AppContext);
  const [isOptimiseOff, setIsOptimiseOff] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (!!userDetails) {
      setIsOptimiseOff(userDetails?.simulation_mode);
      setIsLoading(false);
    }
  }, [userDetails]);

  const handleSwitchChange = async (newState) => {
    setIsOptimiseOff(!newState);
    setIsSaving(true);
    updateUserDetails(
      {
        battery_soc_lower_limit: userDetails.battery_details.soc_lower_limit,
        battery_soc_upper_limit: 100,
        simulation_mode: !newState,
      },
      userSub
    )
      .then(() => {
        setIsSaving(false);
        loadUser();
      })
      .catch((e) => {
        console.error(e);
        setIsSaving(false);
        setShowError(true);
      });
  };

  const titleText = `${theme.language.appName} is ${isOptimiseOff ? 'OFF' : 'ON'}`;

  // Switching this toggle to DISABLED will turn ON simulation mode.
  // This will in turn disable optimise.
  // You are then presented with the text which will prompt you to enable it.
  const isOptimiseDisabledText = isOptimiseOff ? (
    <>
      {theme.language.appName} is currently <b>OFF</b>. You can turn <b>ON</b> {theme.language.appName} using the button
      below - this will allow {theme.language.appName} to control your battery. We are not able to show your battery
      status or any savings while {theme.language.appName} is <b>OFF</b>.
    </>
  ) : (
    <>
      {theme.language.appName} is currently <b>ON</b>. You can turn <b>OFF</b> {theme.language.appName} using the button
      below - this will stop {theme.language.appName} controlling your battery. We will not be able to show your battery
      status or any savings while {theme.language.appName} is <b>OFF</b>.
    </>
  );

  return (
    <InformationPanel title={titleText}>
      <li>
        {isOptimiseDisabledText}
        <Toggle
          switchOn={!isOptimiseOff}
          isLoading={isLoading}
          isSaving={isSaving}
          handleSwitchChange={handleSwitchChange}
          offLabel="ON"
          onLabel="OFF"
        />
      </li>
    </InformationPanel>
  );
};

export default OnOffSettings;
